import React from 'react';
import {IonSelectOption} from '@ionic/react';
import {SignType} from './sign.types';
import Modal from '../../components/modal/modal.component';
import Form from '../../components/form'
import {StyledField} from "@app/becameTeamMemberPage/becameTeamMemberPage.style";
import {StyledIonSelect} from "@components/form/input/select.style";
import {useTranslation} from "react-i18next";

type SignTypeSelectModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onSelect: (signType: SignType) => void;
};

const SignTypeSelectModal: React.FC<SignTypeSelectModalProps> = ({isOpen, onClose, onSelect}: SignTypeSelectModalProps) => {
    const {t} = useTranslation();

    const handleClose = () => {
        onClose();
    }

    const handleSelect = (signType: SignType) => {
        onSelect(signType);
        onClose();
    }

    return (
        <Modal
            isOpen={isOpen}
            onDidDismiss={() => handleClose()}
        >
            <Form.Container>
                <StyledField>
                    <label>{t("sign.signType.label")}</label>
                    <StyledIonSelect className="bolded" okText={t('common.selectOk')}
                                     cancelText={t('common.selectCancel')}
                                     name="signType"
                                     justify="end"
                                     interfaceOptions={
                                         {
                                             header: t("sign.signType.label")
                                         }
                                     }
                                     onIonChange={e => handleSelect(e.detail.value)}
                    >
                        <IonSelectOption key="phoneNumber" value={SignType.PHONE}>{t("sign.signType.phone")}</IonSelectOption>
                        <IonSelectOption key="email" value={SignType.EMAIL}>{t("sign.signType.email")}</IonSelectOption>
                    </StyledIonSelect>
                </StyledField>
            </Form.Container>
        </Modal>
    );
};

export default SignTypeSelectModal;